import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SpecialPeriodModel } from '../models/specialperiod.model';
import { SpecialPeriodService } from '../models/specialperiod.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-specialperiod-list',
  template: require('../views/specialperiod-list.component.html'),
  providers: [SpecialPeriodService]
})
export class SpecialPeriodListComponent implements OnInit {
  DataListModel: DataListModel;
  specialPeriodServiceList: SpecialPeriodService[];
  errorMessage: string;
  isLoading: boolean;
  urlDefaultPage: string;
  urlSpecialPeriodpdate: string;
  private module: string;
  private breadCrumbList: string;

  constructor(private specialPeriodService: SpecialPeriodService,
    private authService: AuthService,
    private router: Router, private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblSpecialPeriod')
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["specialPeriodName", "sunFlag", "monFlag", "tueFlag", "wedFlag", "thuFlag", "friFlag", "satFlag"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlSpecialPeriodpdate = this.authService.GetURL(ApplicationRouteURL.URL_SPECIAL_PERIOD_UPDATE)
    this.GetSpecialPeriodList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSpecialPeriodList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetSpecialPeriodList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSpecialPeriodList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSpecialPeriodList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.specialPeriodService.ExportSpecialPeriodList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "SpecialPeriodList" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetSpecialPeriodList() {
    this.isLoading = true;
    this.specialPeriodService.GetSpecialPeriodList(this.DataListModel)
      .subscribe(
      res => {
        this.specialPeriodServiceList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/specialperiod/components/specialperiod-list.component.ts